import { asPage } from 'src/components/hoc/asPage'
import { SolutionsEditor } from 'src/compositions/Profile/Solutions'

export default asPage(SolutionsEditor, { pageTitle: 'ソリューションの編集' })
